import { sendActionToBot } from './actions.js';
import { handleCustomerActionGate } from './beta-wip.js';
import { apiFetchJSON } from '../core/api.js';
import { openOrderChat } from '../features/orders/order-chat.js';
import type { OrdersApiResponse } from '../types/api.js';

document.querySelectorAll('.service-card').forEach((card) => {
  if (!(card instanceof HTMLElement)) return;
  card.addEventListener('click', () => {
    const action = card.dataset.action || '';
    if (!handleCustomerActionGate(action)) return;
    const label = card.querySelector('.service-title')?.textContent?.trim() || 'Услуга';
    const desc = card.querySelector('.service-desc')?.textContent?.trim();
    const fullLabel = desc ? `${label} — ${desc}` : label;
    sendActionToBot(action, fullLabel);
  });
});

// Deep-link support from Telegram inline "Open" button.
(function applyInitialOpenActionFromUrl() {
  try {
    const q = new URLSearchParams(window.location.search || '');
    const open = String(q.get('open') || '').trim().toLowerCase();
    if (open === 'consult') {
      setTimeout(function () {
        try {
          sendActionToBot('consult', 'Открыть чат');
        } catch (_) {}
      }, 60);
      return;
    }
    if (open === 'order-chat') {
      const orderId = String(q.get('orderId') || '').trim();
      if (!orderId) return;
      setTimeout(function () {
        apiFetchJSON<OrdersApiResponse>('/api/my-orders', { method: 'GET' })
          .then(function (data) {
            if (!data || !data.ok) return;
            const items = Array.isArray(data.items) ? data.items : Array.isArray(data.orders) ? data.orders : [];
            const order = items.find(function (o) {
              return o && String(o.id || o.orderId) === orderId;
            });
            if (!order) return;
            const oid = String(order.id || order.orderId || orderId);
            openOrderChat({
              orderId: oid,
              orderTitle: String(order.title || ''),
              backTo: 'view-main'
            });
          })
          .catch(function () {});
      }, 60);
    }
  } catch (_) {}
})();
